import axios from "axios";

export const LOGIN = "admin/auth/login";
export const REFRESH_TOKEN = "admin/auth/refresh-token";
export const LIST_USER = "admin/info/list-user";
export const LIST_USER_EXCEL = "admin/info/list-user/export-excel";
export const LIST_ADMIN = "admin/info/list";
export const REGISTER = "admin/auth/register";
export const LOCK_USER = "admin/auth/lock-user";
export const LOCK_ADMIN = "admin/auth/lock";
export const UNLOCK_USER = "admin/auth/unlock-user";
export const UNLOCK_ADMIN = "admin/auth/unlock";
export const CONVERSION_HIS = "admin/info/exchange-history";
export const CONVERSION_HIS_EXCEL = "admin/info/exchange-history/export-excel";
/** Lịch sử user tham gia — GET */
export const PLAY_HIS = "admin/info/user-participation-history";
/** Xuất Excel — POST (body `{}`), query lọc giống list (vd. username) */
export const PLAY_HIS_EXCEL = "admin/info/user-participation-history/export-excel";
export const GAMING_HIS = "admin/info/predict-match-history";
export const GAMING_HIS_EXCEL = "admin/info/predict-match-history/export-excel";
/** Chi tiết từng lượt dự đoán theo user + trận — GET `?username=&matchId=` */
export const GAMING_PREDICT_MATCH_DETAILS =
  "admin/info/predict-match-details";
export const CONFIG = "admin/info/predict-match-config";
export const UPDATE_CONFIG = "admin/info/predict-match-config/bulk";
/** Upload ảnh chung kết — POST multipart/form-data với field `file` */
export const UPLOAD_FINAL_IMAGE = "admin/info/predict-match-config/upload-final-image";
export const UPDATE_TURN_USER = "admin/info/update-user-turns";
export const UPDATE_USER_FAKE = "admin/info/predict-match/fake-users";
/** Đồng bộ / cập nhật trận ASEAN Cup (admin) — POST body `{ matches: [...] }` (gồm `isAllowed`) */
export const SYNC_MATCHES = "asean-cup/admin/sync-matches";
/** Lịch trận ASEAN Cup (admin) — GET danh sách màn Cài đặt trận đấu / Xác nhận kết quả */
export const MATCH_SCHEDULES = "asean-cup/admin/schedules";
export const WORLD_CUP_SCHEDULES = MATCH_SCHEDULES;
export const worldCupScheduleUrl = (scheduleId) =>
  `${MATCH_SCHEDULES}/${encodeURIComponent(String(scheduleId))}`;
/** Admin cập nhật tỉ số — POST `/:matchId` body `{ homeScore, awayScore }` */
export const UPDATE_MATCH_SCORE_BASE = "asean-cup/admin/update-score";
export const updateMatchScoreUrl = (matchId) => `${UPDATE_MATCH_SCORE_BASE}/${matchId}`;
/** Admin duyệt kết quả trận — POST `/:matchId`, không body */
export const APPROVE_MATCH_RESULT_BASE = "asean-cup/admin/approve-result";
export const approveMatchResultUrl = (matchId) => `${APPROVE_MATCH_RESULT_BASE}/${matchId}`;
/** BXH tổng hợp — màn Leaderboard */
export const COMBINED_RANKINGS = "admin/info/combined-rankings";
/** Fake BXH — CRUD màn Cài đặt BXH: GET/POST collection; PATCH/DELETE `/:id` */
export const LEADERBOARD_RANKING = "admin/info/user-fake-rankings";
export const userFakeRankingUrl = (id) =>
  `${LEADERBOARD_RANKING}/${encodeURIComponent(String(id))}`;
export const EDIT_USER_FAKE = "admin/info/user-fake-notifications";
export const DELETE_USER_FAKE = "admin/info/user-fake-notifications";
export const LIST_REWARD_CLAIM = "admin/info/predict-match/reward-claims";
export const ADD_USER_FAKE = "admin/info/user-fake-notifications";
export const LIST_USER_FAKE = "admin/info/user-fake-notifications";
// Admin Inventory
export const ADMIN_INVENTORY_SUMMARY = "admin/inventory/summary";
export const ADMIN_INVENTORY_GIFTS = "admin/inventory/gifts";
// Gift history
export const GIFT_HIS = "admin/info/predict-match-gift-history";
export const GIFT_HIS_EXCEL = "admin/info/predict-match-gift-history/export-excel";

// Treasure Hunt Monitor Statistics
export const DAILY_PARTICIPANTS = "admin/info/daily-participants";
export const VIP_USER_COUNTS = "admin/info/vip-user-counts";
export const VIP_TOTAL_SCORES = "admin/info/vip-total-scores";
export const SUMMARY_STATS = "admin/info/summary-stats";
export const DEPOSIT_STATS = "admin/info/deposit-stats";
export const TOTAL_SCORE_STATS = "admin/info/total-score-stats";

// User management
export const USER = "admin/info/user";

// Setting Winner
export const HISTORY_STAR = {
  createTicket3: "admin/info/history-star/create-ticket3"
};
export const Ticket3 = "admin/info/ticket3";

//--------------
const baseURL = "https://dt68-api-dudoan.syp400.com/api/v1/";

// Tạo axios instance để giữ nguyên cấu trúc
const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor để thêm token và handle baseURL
axiosInstance.interceptors.request.use(
  (config) => {
    const auth = localStorage.getItem("auth");
    if (auth) {
      const authData = JSON.parse(auth);
      config.headers.Authorization = `${authData.tokenType} ${authData.accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor để xử lý lỗi authentication
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      const auth = localStorage.getItem("auth");
      if (auth) {
        const authData = JSON.parse(auth);
        try {
          await refreshToken(authData.refreshToken);
          // Retry original request
          return API(originalRequest);
        } catch (refreshError) {
          // Refresh failed, redirect to login
          localStorage.clear();
          window.location.assign("/login");
          return Promise.reject(refreshError);
        }
      } else {
        // No auth data, redirect to login
        window.location.assign("/login");
      }
    }
    
    return Promise.reject(error);
  }
);

const refreshToken = async (refreshTokenValue) => {
  const params = {
    refreshToken: refreshTokenValue
  };

  const response = await API.post(REFRESH_TOKEN, params);
  
  if (response.data?.data) {
    const data = response.data.data;
    const dataAuth = {
      tokenType: "Bearer",
      accessToken: data.token,
      refreshToken: data.refreshToken,
      username: data.username,
      role: data.role,
    };
    localStorage.setItem("auth", JSON.stringify(dataAuth));
    return dataAuth;
  } else {
    throw new Error("Invalid refresh token response");
  }
};

// Export axios instance trực tiếp để gọi API thật
const API = axiosInstance;

export default API;